import { FormGroup, Label, Input, Button } from "reactstrap";

import styles from "./Form.module.css";

const Step5 = (props) => {
  if (props.currentStep !== 5) {
    return null;
  }

  return (
    <>
      {props.isCreating && <h4>{props.stepTitle}</h4>}
      <FormGroup>
        <Label for="script_name">Nome do Script</Label>
        <Input
          type="text"
          name="title"
          id="title"
          placeholder="Insira o nome do Script"
          value={props.scriptName}
          onChange={props.handleScriptChange}
        />
        <Label className="mt-4" for="script_name">
          Código do Script:
        </Label>
        <Input
          type="textarea"
          name="code"
          id="code"
          placeholder="Insira o código do Script"
          value={props.scriptCode}
          onChange={props.handleScriptChange}
        />
        <FormGroup>
          <Label className="mt-4" for="exampleSelect">
            Tipo/Posição do script:
          </Label>
          <div className="centerr">
            <select
              value={props.borderStyle}
              name="position"
              onChange={props.handleLinkStyleChange}
              style={{ width: "30%" }}
            >
              <option
                style={{ textAlign: "center" }}
                name="borderStyle"
                value="head"
              >
                Head
              </option>
              <option
                style={{ textAlign: "center" }}
                name="borderStyle"
                value="body"
              >
                Body
              </option>
              <option
                style={{ textAlign: "center" }}
                name="borderStyle"
                value="gtm"
              >
                GTM
              </option>
            </select>
          </div>
        </FormGroup>
        <div className="centerr">
          <Button
            onClick={props.handleNewScript}
            className={styles.button_form}
            color="primary mt-5"
          >
            Adicionar Script
          </Button>
        </div>
      </FormGroup>
    </>
  );
};

export default Step5;
